import styled from 'styled-components';

export const SignupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  padding: 30px 20px;
  width: 100%;
  @media (min-width: 481px) {
    padding: 30px 0px;
  }
  @media (min-width: 992px) {
    flex-direction: row;
  }
`;

export const SignupWrapper = styled.div`
position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem 1rem;
  width: 100%;
  max-width: var(--layoutMaxWidth);
  margin: 0px auto;
  background-color: ${({ variant }) =>
    variant === 'partner-plus'
      ? 'var(--partnerLightBg)'
      : variant === 'regionals'
      ? 'var(--regionalsLightBg)'
      : variant === 'code-juniors'
      ? 'var(--juniorsLightBg)'
      : 'var(--siteSecondaryBgColor)'};
      border-radius: 25px;
      overflow: hidden;
  z-index: 0;
  @media (min-width: 320px) {
    padding: 2.5rem 1.5rem;
  }
  @media (min-width: 481px) {
    width: 75%;
  }
  @media (min-width: 576px) {
    width: 70%;
  }
  @media (min-width: 768px) {
    width: 95%
    padding: 3rem;
  }
    @media (min-width: 992px) {
      width: var(--layoutWidth);
    }
`;

export const SignupInfoTitle = styled.h2`
  text-align: center;
  padding-bottom: 30px;
  z-index: 1;
  max-width: 650px;
  @media (min-width: 1200px) {
    max-width: 680px;
  }
  @media (min-width: 1400px) {
    max-width: 820px;
  }
  @media (min-width: 1800px) {
    max-width: unset;
  }
`;

export const StatsDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  z-index: 1;
  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const SignupStats = styled.div`
  width: 210px;
  padding: 15px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  margin-bottom: ${(props) => props.marginSpacing && '15px'};
  color: var(--darkGreyTxtColor);
  background-color: var(--siteBgColor);
  box-shadow: ${({ variant }) =>
    variant === 'partner-plus' || variant === 'regionals' || variant === 'code-juniors' ? '0px 2px 10px var(--greyShadowColor)' : '0px 0px 15px 6px var(--siteBorderColor)'};
  @media (min-width: 320px) {
    width: 220px;
  }
  @media (min-width: 768px) {
    margin-bottom: ${(props) => props.marginSpacing && '0px'};
    margin-right: ${(props) => props.marginSpacing && '25px'};
  }
`;

export const SignupInfoShape = styled.object`
  display: none;
  position: absolute;
  width: 150px;
  z-index: 0;
  transform: ${(props) => props.bottomLeft && 'rotateZ(180deg)'};
  @media (min-width: 992px) {
    display: block;
    top: ${(props) => props.topRight && '0px'};
    right: ${(props) => props.topRight && '0px'};
    bottom: ${(props) => props.bottomLeft && '0px'};
    left: ${(props) => props.bottomLeft && '0px'};
  }
  @media (min-width: 1200px) {
    width: 160px;
  }
  @media (min-width: 1400px) {
    width: 180px;
  }
  @media (min-width: 1600px) {
    width: 200px;
  }
`;

// Blue pattern CTA card styles
export const CardContainer = styled.div`
  width: 100%;
  padding: 30px 20px;
  @media (min-width: 481px) {
    padding: 30px 0px;
  }
`;

export const OuterCard = styled.div`
  width: 100%;
  margin: 0px auto;
  position: relative;
  overflow: hidden;
  border-radius: 25px;
  z-index: 0;
  background-color: var(--brandColor);
  @media (min-width: 481px) {
    width: 75%;
  }
  @media (min-width: 576px) {
    width: 70%;
  }
  @media (min-width: 768px) {
    width: 90%;
  }
  @media (min-width: 1200px) {
    width: var(--layoutWidth);
    max-width: var(--layoutMaxWidth);
  }
  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(#f8f9fa14 0.9px, transparent 0.9px), linear-gradient(to right, #f8f9fa14 0.9px, var(--brandColor) 0.9px);
    background-size: 18px 18px;
    opacity: 1;
    z-index: -1;
  }
`;

export const InnerCard = styled.div`
  width: 100%;
  padding: 2rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (min-width: 320px) {
    padding: 2.5rem 1.5rem;
  }
  @media (min-width: 768px) {
    padding: 3rem;
  }
`;
